// Migración del componente TablaEquipos a Material UI v5 con DataGrid y barra de búsqueda
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEquipos, subirImagenEquipoInventario, duplicarEquipo, getClientesPorIngeniero, cambiarEquipoCliente } from '../../../redux/actions/dataactions';
import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, CircularProgress, Box, Typography, TextField,
  Select, MenuItem, InputLabel, FormControl, Button
} from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import UploadIcon from '@mui/icons-material/CloudUpload';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Link } from 'react-router-dom';
import { FaMagic, FaFilePdf, FaArrowLeft, FaPlus } from 'react-icons/fa';

import NuevoEquipo from './NuevoEquipo';
import SubirEquipos from '../ClientePerfil/SubirEquipos';
import './TablaEquipos.css';
import MyButton from '../../../utils/MyButton';

class TablaEquipos extends Component {
  state = {
    selectedFile: null,
    open: false,
    equipoid: '',
    openCambiarSede: false,
    clientesIngeniero: [],
    clienteSeleccionado: '',
    mensajeSede: ''
  };

  handleOpen = (equipoid) => {
    this.setState({ open: true, equipoid });
  };

  handleClose = () => {
    this.setState({ open: false, equipoid: '' });
  };

  handleOpenCambiarSede = (equipoid) => {
    const handleuser = this.props.user?.credentials?.handle;
    this.setState({ openCambiarSede: true, equipoid, mensajeSede: '', clienteSeleccionado: '' });
    if (handleuser) {
      this.props.getClientesPorIngeniero(handleuser).then((clientes) => {
        this.setState({ clientesIngeniero: clientes || [] });
      });
    }
  };

  handleCloseCambiarSede = () => {
    this.setState({ openCambiarSede: false, equipoid: '', clienteSeleccionado: '', mensajeSede: '' });
  };

  onChangeClienteSede = (e) => {
    this.setState({ clienteSeleccionado: e.target.value });
  };

  handleCambiarSedeSubmit = () => {
    const { equipoid, clienteSeleccionado } = this.state;
    const { clienteId } = this.props;

    if (!clienteSeleccionado) return;

    this.setState({ mensajeSede: 'Cambiando sede...' });
    this.props.cambiarEquipoCliente(equipoid, clienteId, clienteSeleccionado)
      .then(() => {
        this.setState({ mensajeSede: 'Cambio de cliente realizado con éxito' });
        setTimeout(() => {
          this.handleCloseCambiarSede();
        }, 1500);
      })
      .catch((err) => {
        this.setState({ mensajeSede: 'Error al cambiar sede' });
      });
  };

  onFileChange = event => {
    this.setState({ selectedFile: event.target.files[0] });
  };

  onFileUpload = () => {
    const formData = new FormData();
    formData.append("myFile", this.state.selectedFile, this.state.selectedFile.name);
    this.props.subirImagenEquipoInventario(formData, this.state.equipoid, this.props.clienteId);
    this.setState({ open: false });
  };

  componentDidMount() {
    this.props.getEquipos(this.props.clienteId);
  }

  render() {
    const { equipos, loadingdata } = this.props.data;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 200,
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Tooltip title="Ver Perfil">
              <IconButton
                component={Link}
                to={`/dashboard/perfilcliente/equipo/${this.props.clienteId}/${params.row.equipoid}`}
                size="small"
              >
                <AssignmentIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Subir Imagen">
              <IconButton size="small" onClick={() => this.handleOpen(params.row.equipoid)}>
                <UploadIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Duplicar Equipo">
              <IconButton size="small" onClick={() => this.props.duplicarEquipo(params.row.equipoid, this.props.clienteId)}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cambiar de Sede">
              <IconButton size="small" onClick={() => this.handleOpenCambiarSede(params.row.equipoid)}>
                <SwapHorizIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
      {
        field: 'imagenurl',
        headerName: 'Avatar',
        width: 80,
        renderCell: (params) => (
          <img src={params.row.imagenurl} alt="avatar" style={{ width: 40, borderRadius: '50%' }} />
        )
      },
      { field: 'idinventario', headerName: 'ID', width: 150 },
      { field: 'nombre', headerName: 'Nombre', width: 150 },
      { field: 'marca', headerName: 'Marca', width: 120 },
      { field: 'modelo', headerName: 'Modelo', width: 120 },
      { field: 'serie', headerName: 'Serie', width: 120 },
      { field: 'ubicacion', headerName: 'Ubicación', width: 130 },
      { field: 'servicio', headerName: 'Servicio', width: 130 },
      { field: 'estado', headerName: 'Estado', width: 100 },
      { field: 'registroinvima', headerName: 'Invima', width: 120 },
      { field: 'riesgo', headerName: 'Riesgo', width: 100 }
    ];

    return (
      <Box>
        {!loadingdata ? (
          <Fragment>
            <Box className="inventory-links-grid">
              <Link className='div-card-link' to={`/dashboard/perfilcliente/nuevoequipoia/${this.props.clienteId}`}>
                <div className="dashing-cardcontent">
                  <div className="dashing-cardtext">
                    <p className="dashing-text-card">Nuevo Equipo IA</p>
                  </div>
                  <div className="dashing-cardicon-blue">
                    <FaMagic color="#FFFFFF" className="dashing-icon" />
                  </div>
                </div>
              </Link>
              <NuevoEquipo clienteId={this.props.clienteId} />
              <SubirEquipos clienteId={this.props.clienteId} />
              <Link className='div-card-link' to={`/dashboard/perfilcliente/inventario/${this.props.clienteId}`} state={equipos}>
                <div className="dashing-cardcontent">
                  <div className="dashing-cardtext">
                    <p className="dashing-text-card">Exportar Inventario</p>
                  </div>
                  <div className="dashing-cardicon-green">
                    <FaFilePdf color="#FFFFFF" className="dashing-icon" />
                  </div>
                </div>
              </Link>
            </Box>

            <Box sx={{ height: 600, width: '100%', mt: 2, '& .MuiDataGrid-columnHeaders': { backgroundColor: 'primary.main', color: 'white' } }}>
              <DataGrid
                rows={equipos.map((row, index) => ({ id: index, ...row }))}
                columns={columns}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                components={{
                  Toolbar: () => (
                    <Box p={1}><GridToolbarQuickFilter placeholder="Buscar equipo..." /></Box>
                  )
                }}
              />
            </Box>

            <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
              <DialogTitle>Subir Imagen del Equipo</DialogTitle>
              <DialogContent>
                <TextField type="file" onChange={this.onFileChange} inputProps={{ accept: 'image/png,image/jpeg' }} fullWidth />
              </DialogContent>
              <DialogActions>
                <Tooltip title="Cerrar">
                  <IconButton onClick={this.handleClose}><ArrowBackIcon /></IconButton>
                </Tooltip>
                <Tooltip title="Subir Imagen">
                  <IconButton onClick={this.onFileUpload}><AddIcon /></IconButton>
                </Tooltip>
              </DialogActions>
            </Dialog>

            <Dialog open={this.state.openCambiarSede} onClose={this.handleCloseCambiarSede} fullWidth maxWidth="sm">
              <DialogTitle>
                <Typography sx={{
                  fontSize: '20px',
                  fontWeight: 600,
                  color: '#0468BF',
                  textAlign: 'center'
                }}>Cambiar de Sede (Cliente)</Typography></DialogTitle>
              <DialogContent>
                {this.state.mensajeSede && (
                  <Typography color="primary" sx={{ mb: 2, mt: 1 }}>{this.state.mensajeSede}</Typography>
                )}
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <InputLabel id="select-cliente-label">Seleccionar Nuevo Cliente</InputLabel>
                  <Select
                    labelId="select-cliente-label"
                    value={this.state.clienteSeleccionado}
                    label="Seleccionar Nuevo Cliente"
                    onChange={this.onChangeClienteSede}
                  >
                    {this.state.clientesIngeniero.map((c) => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.nombre} - {c.sede} ({c.ciudad})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </DialogContent>
              <DialogActions>
                <MyButton tip="Cerrar" onClick={this.handleCloseCambiarSede}>
                  <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
                </MyButton>
                <MyButton tip="Cambiar" onClick={this.handleCambiarSedeSubmit}>
                  <FaPlus color="#03178C" className="icon-formulario" />
                </MyButton>
              </DialogActions>
            </Dialog>
          </Fragment>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
            <CircularProgress />
          </Box>
        )}
      </Box>
    );
  }
}

TablaEquipos.propTypes = {
  getEquipos: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired,
  subirImagenEquipoInventario: PropTypes.func.isRequired,
  duplicarEquipo: PropTypes.func.isRequired,
  getClientesPorIngeniero: PropTypes.func.isRequired,
  cambiarEquipoCliente: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user
});

export default connect(mapStateToProps, { getEquipos, subirImagenEquipoInventario, duplicarEquipo, getClientesPorIngeniero, cambiarEquipoCliente })(TablaEquipos);
